import { render, staticRenderFns } from "./actividad-poblacion-ars.vue?vue&type=template&id=17a58a7c&"
import script from "./actividad-poblacion-ars.component.ts?vue&type=script&lang=ts&"
export * from "./actividad-poblacion-ars.component.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports